import { h, Component, Fragment } from "preact";
import { useContext } from "preact/hooks";
import { TranslateContext } from "@denysvuika/preact-translate";
import layers from "./layers";
import Map from "./map";
import { select } from "underscore";

export default class MapContainer extends Component {
  state = {
    openGroup: "panorama",
    selectedLayer: null,
  };
  constructor() {
    super();
    const args = this.getArgs();
    if (args.layer=='z') {
        this.state = {
          selectedLayer: 'z',
          openGroup:'services'
        };
    }
  }
  getArgs() {
    var args = {};
    var query = location.search.substring(1);
    if (query) {
      query.split("&").map(function (el) {
        var arg = el.split("=");
        if (arg[1]) args[arg[0]] = arg[1];
      });
    }
    return args;
  }
  componentDidMount() {
    const args = this.getArgs();
    if (args.layer) {
      setTimeout(()=>{
        this.setState({selectedLayer: args.layer,
      openGroup:'services'});
      },100);
    }
  }
  render() {
    const { t, lang } = useContext(TranslateContext);
    const { state } = this;
    let { openGroup, selectedLayer } = state;

    if (!selectedLayer) {
      const cand = layers
        .filter((group) => group.key == openGroup)
        .map((group) => group.children[0]);
      selectedLayer = cand && cand.length ? cand[0].key : null;
    }
    // console.log("selectedLayer", selectedLayer);
    return (
      <div id="locations">
        <div class="container">
          <div class="filter" style="padding-bottom: 0;">
            {layers.map((group) => (
              <Fragment>
                <div
                  class="header"
                  style="cursor:pointer;"
                  onClick={() => {
                    this.setState({
                      openGroup: openGroup == group.key ? null : group.key,
                      selectedLayer:
                        openGroup == group.key ? selectedLayer : null,
                    });
                  }}
                >
                  {t(group.title)}
                </div>
                {openGroup == group.key && (
                  <ul id="kartesfiltri">
                    {group.children.map(({ img, ...child }) => (
                      <li
                        {...child}
                        class={selectedLayer == child.key ? "active" : ""}
                        onClick={() => {
                          console.log("group.k", group.key, state.openGroup);
                          this.setState({
                            selectedLayer:
                              child.key.indexOf("all") !== -1
                                ? null
                                : child.key,
                          });
                        }}
                      >
                        {img ? (
                          !!img.length && (
                            <img
                              src={`/img/markers/${
                                selectedLayer == child.key ? img[1] : img[0]
                              }`}
                              alt=""
                            />
                          )
                        ) : (
                          <img src={`/img/markers/${child.key}.png`} alt="" />
                        )}
                        {t(child.title)}
                      </li>
                    ))}
                  </ul>
                )}
              </Fragment>
            ))}
          </div>
        </div>
        <Map openGroup={openGroup} selectedLayer={selectedLayer} layers={layers} />
      </div>
    );
  }
}
